import { InjectionToken } from '@angular/core';

import { IEnvironmentVariables } from './IEnvironment';

export const ENV = new InjectionToken<IEnvironmentVariables>('ENV');
